export default __webpack_public_path__ + "static/media/ghoststories.a72a9939.jpg";